export default __webpack_public_path__ + "static/media/nav_point.0d525848.svg";